import React from "react";
import "./DotTypingAnimation.css";

const DotTypingAnimation = ({ text, isAnimationRequired }) => {
  return (
    <div className="dot-type-animation">
      {text}
      <div className={isAnimationRequired ? "dot-typing" : ""}></div>
    </div>
  );
};

export default DotTypingAnimation;
